export default __webpack_public_path__ + "static/media/Lightning-box.58540858.png";